import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";

interface Props {
  value: string;
  className?: string;
  highlightOnChange?: boolean;
}

// Component to animate price changes with highlight effect
const AnimatedPrice: React.FC<Props> = React.memo(
  ({
    //
    value,
    className = "",
    highlightOnChange = true
  }: Props) => {
    const [prevValue, setPrevValue] = useState(value);
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
      // Only animate if the value actually changed (not on initial mount)
      if (value !== prevValue && prevValue !== "") {
        setIsUpdating(true);
        setPrevValue(value);
        const timer = setTimeout(() => setIsUpdating(false), 2000);
        return () => clearTimeout(timer);
      } else if (prevValue === "") {
        // Initial mount - just set the value without animation
        setPrevValue(value);
      }
    }, [value, prevValue]);

    return (
      <motion.span
        className={className}
        animate={
          isUpdating && highlightOnChange
            ? {
                backgroundColor: [
                  "rgba(34, 197, 94, 0)",
                  "rgba(34, 197, 94, 0.3)",
                  "rgba(34, 197, 94, 0)"
                ],
                scale: [1, 1.05, 1]
              }
            : {}
        }
        transition={{
          duration: 1.5,
          ease: "easeInOut"
        }}
      >
        <AnimatePresence mode="wait">
          <motion.span
            key={value}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
          >
            {value}
          </motion.span>
        </AnimatePresence>
      </motion.span>
    );
  }
);
AnimatedPrice.displayName = "AnimatedPrice";

export { AnimatedPrice };
